export const REQUEST_OAUTH_PARAMETERS = "requestOauthParameters";
export const REQUEST_LOGIN = "requestLogin";
export const REQUEST_LOGIN_STATUS = "requestLoginStatus";
export const REQUEST_FETCH_USER_DETAILS = "requestFetchUserDetails";
export const REQUEST_LOGOUT = "requestLogout";
export const REQUEST_FETCH_TOKEN = "requestFetchToken";
export const UPDATE_COMPLETED_STORIES = "updateCompletedStories";
export const FETCH_COMPLETED_STORIES = "fetchCompletedStories";
